import { render, staticRenderFns } from "./PgaOfferEvaluationCustomerOrderTable.vue?vue&type=template&id=d71e4fb0&"
import script from "./PgaOfferEvaluationCustomerOrderTable.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationCustomerOrderTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d71e4fb0')) {
      api.createRecord('d71e4fb0', component.options)
    } else {
      api.reload('d71e4fb0', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationCustomerOrderTable.vue?vue&type=template&id=d71e4fb0&", function () {
      api.rerender('d71e4fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/tables/PgaOfferEvaluationCustomerOrderTable.vue"
export default component.exports